import React from "react";
import AdminHeader from "../components/Layout/AdminHeader";
import AdminSideBar from "../components/Admin/Layout/AdminSideBar";
import AllSellers from "../components/Admin/AllSellers";

const AdminDashboardSellers = () => {
  return (
    <div className="admin-dashboard-container">
      <AdminHeader />
      <div className="admin-dashboard-content">
        <div className="admin-dashboard-wrapper">
          <div className="admin-dashboard-sidebar">
            <AdminSideBar active={3} />
          </div>
          <div className="admin-dashboard-main admin-dashboard-sellers-main admin-page-shell">
            <header className="admin-page-hero">
              <div>
                <p className="admin-page-eyebrow">Super Admin Shops</p>
                <h1>All Sellers</h1>
                <p className="admin-page-copy">Monitor shop activity, seller status, and marketplace performance from one admin surface.</p>
              </div>
            </header>
            <AllSellers />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardSellers;
